import { render, staticRenderFns } from "./Resetpassword.vue?vue&type=template&id=41a131a6&scoped=true&"
import script from "./Resetpassword.vue?vue&type=script&lang=js&"
export * from "./Resetpassword.vue?vue&type=script&lang=js&"
import style0 from "./Resetpassword.vue?vue&type=style&index=0&id=41a131a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a131a6",
  null
  
)

export default component.exports